<div class="col my-3">
  <div class="card text-dark bg-light">
    <div class="card-body">
      <slot />
    </div>
  </div>
</div>
